import styled from 'styled-components'
import { Button, Tooltip } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useIntake } from '../../contexts/IntakeContext'
import { CaffeinePressableListCount, StepsHeader } from '../../components'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`

const CaffeineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
`

const CaffeineOptionsContainer = styled.div`
  padding-top: 12px;
  margin: 24px 0 24px 0;
  overflow-y: scroll;

  @media screen and (min-height: 1024px) {
    max-height: 65vh;
  }

  @media screen and (max-height: 1024px) {
    max-height: 60vh;
  }

  @media screen and (max-height: 860px) {
    max-height: 50vh;
  }

  @media screen and (max-height: 768px) {
    max-height: 42vh;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  position: fixed;
  height: 36px;
  bottom: 44px;
  left: 44px;
  right: 44px;
  margin-bottom: 0px;
`

const IntakeCaffeineType = ({ step, onNext, onPrevious, onFinish }) => {
  const {
    caffeineProducts,
    selectedCaffeineOptions,
    setSelectedCaffeineOptions,
  } = useIntake()

  const { t } = useTranslation('common')
  const handleClear = () => {
    setSelectedCaffeineOptions([])
  }

  return (
    <Container>
      <div>
        <StepsHeader
          stepText={step}
          description={t('caffeine.time.description')}
        />

        <CaffeineContainer>
          <span style={{ fontSize: 24, fontWeight: 700, textAlign: 'center' }}>
            {t('caffeine.time.question')}
          </span>
          <span style={{ fontSize: 18, textAlign: 'center' }}>
            {t('caffeine.time.input_request')}
          </span>
          {caffeineProducts?.length > 0 && (
            <CaffeineOptionsContainer>
              <CaffeinePressableListCount
                caffeineProducts={caffeineProducts}
                selectedOptions={selectedCaffeineOptions}
                onSelectOption={setSelectedCaffeineOptions}
              />
            </CaffeineOptionsContainer>
          )}
        </CaffeineContainer>
      </div>
      <Footer>
        <Button
          variant='text'
          onClick={onPrevious}
          startIcon={<ArrowBackIcon />}
        >
          {t('caffeine.type.return')}
        </Button>
        <div>
          <Button
            variant='outlined'
            onClick={handleClear}
            style={{ marginRight: 24 }}
          >
            {t('caffeine.type.clear')}
          </Button>
          {selectedCaffeineOptions.length <= 0 ? (
            <Tooltip
              title='Selecione ao menos uma das opcões'
              placement='top'
              arrow
            >
              <span>
                <Button
                  variant='contained'
                  disabled
                >
                  {t('caffeine.type.finish')}
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Button
              variant='contained'
              onClick={
                selectedCaffeineOptions[0]?.isNoCaffeine ? onFinish : onNext
              }
            >
              {selectedCaffeineOptions[0]?.isNoCaffeine
                ? t('caffeine.time.finish')
                : t('caffeine.type.finish')}
            </Button>
          )}
        </div>
      </Footer>
    </Container>
  )
}

export default IntakeCaffeineType
